/**
 * Created by guga on 7/21/2016.
 */
 import {ItemBean} from './item.bean';
 import {RecipeRequisiteBean} from './recipe.requisite.bean';
 import {SpacialBean} from './spacial.bean';
 import {EquipItemBean} from './equip.item.bean'
 export class RecipeBean {

    public id : string; //IDENTIFIER OF THIS recipe
    public name: string; //Item name;
    public baseQuantity:number //how many of this item is base to be added on skill success
    public description:string
    public cost: number; //sugested cost for item
    public maxSkill:number //max skill that is awareded on this item
    public minSkill:number//min skill to start making this item
    public requisite:Array<RecipeRequisiteBean>//list of other recipes
    public skill;//skill for this recipe
    public skillId:number
    public timeInSeconds:number //for awarding triggers on time
    public tokenId:string

    //item related
    public kind: string; //Behaviour for the item
    public action: string; //Behaviour for the item;
    public closeAction: string;  
    public param:any
    public closeParam:any


    public model: string;
    public thumbnail:string //address of uncolored image
    public src:string //source for uncolored avatar animation
    public colours:[]
    public size: number;
    public orientation: number;

    public where:string //where it is equiped
    public dimension: SpacialBean
    public collision: boolean;
    public baseItem:string

    constructor (){
        let date=new Date();
        let time=date.getTime();


        this.id=time.toString(); //IDENTIFIER OF THIS recipe
        this.name="" //Item name;
        this.baseQuantity=0; //how many of this item is base to be added on skill success
        this.description="";
        this.cost=0; //sugested cost for item
        this.maxSkill=0 //max skill that is awareded on this item
        this.minSkill=0//min skill to start making this item
        this.requisite=[]//list of other recipes
        this.skill={};//skill for this recipe
        this.skillId=0
        this.timeInSeconds=0 //for awarding triggers on time
        this.tokenId='';



            //item related
        this.kind=""; //Behaviour for the item
        this.action=""; //Behaviour for the item;
        this.closeAction=""
        this.param={}
        this.closeParam={} 

    
        this.model=""; //to show when you click the object
        this.thumbnail=""; //address of uncolored image
        this.src=""; //source for uncolored avatar animation
        this.colours=[]
        this.size=1
        this.orientation=Math.PI/4


        this.where=""; //where it is equiped
        this.dimension=new SpacialBean();
        this.collision=false
        this.baseItem=''
        
    }
    public parse(val){
        this.id=val.id ? val.id : ''; //IDENTIFIER OF THIS recipe
        this.name=val.name ? val.name : ''//Item name;
        this.baseQuantity=val.baseQuantity ? val.baseQuantity : 0; //how many of this item is base to be added on skill success
        this.description=val.description ? val.description : ''
        this.cost=val.cost ? val.cost : 0; //sugested cost for item
        this.maxSkill=val.maxSkill ? val.maxSkill : 0//max skill that is awareded on this item
        this.minSkill=val.minSkill ? val.minSkill : 0//min skill to start making this item
        this.requisite=[]
        this.baseItem=val.baseItem ? val.baseItem : ''
        if (val.requisite){
            val.requisite.forEach(v=>{
                let req= new RecipeRequisiteBean()//list of other recipes
                 req.parse(v);
                 this.requisite.push(req)
             })     
        }
        this.skill=val.skill ? val.skill : {};//skill for this recipe
        this.skillId=val.skillId ? val.skillId : 0
        this.timeInSeconds=val.timeInSeconds ? val.timeInSeconds : 0//for awarding triggers on time
        this.tokenId=val.tokenId ? val.tokenId : '';
        
        //item related
        this.kind=val.kind ? val.kind : ''; //Behaviour for the item
        this.action=val.action ? val.action : ''; //Behaviour for the item;
        this.closeAction=val.closeAction ? val.closeAction : '';
        this.param = val.param ? val.param : {};
        this.closeParam = val.closeParam ? val.closeParam : {}        

        this.model= val.model ? val.model : '';
        this.thumbnail=val.thumbnail ? val.thumbnail : ''; //address of uncolored image
        this.src=val.src ? val.src : ''; //source for uncolored avatar animation
        this.colours = val.colours ? val.colours : []
        this.size = val.size ? val.size : 1
        this.orientation = val.orientation ? val.orientation : Math.PI/4

   
        this.where=val.where ? val.where : ''; //where it is equiped
        let dimension=new SpacialBean();
        dimension.parse(val.dimension)
        this.dimension=dimension;
        this.collision=val.collision ? val.collision : ''
        this.baseItem = val.baseItem ? val.baseItem : ''
    }
    public toDB() {
        let requisites=[]
        this.requisite.forEach(val=>{
            let req=val.toDB();
            requisites.push(req)
        })
        return {
            id : this.id, //IDENTIFIER OF THIS recipe
            name: this.name, //Item name;
            baseQuantity:this.baseQuantity, //how many of this item is base to be added on skill success
            description: this.description,
            cost: this.cost, //sugested cost for item
            maxSkill:this.maxSkill, //max skill that is awareded on this item
            minSkill:this.minSkill,//min skill to start making this item
            requisite:requisites,//list of other recipes
            skill:this.skill,//skill for this recipe
            skillId:this.skillId,
            timeInSeconds:this.timeInSeconds, //for awarding triggers on time
            tokenId: this.tokenId,

            //item related
            kind: this.kind, //Behaviour for the item
            action: this.action, //Behaviour for the item;
            closeAction : this.closeAction,
            param: this.param,
            closeParam: this.closeParam,

            model: this.model,
            thumbnail:this.thumbnail, //address of uncolored image
            src:this.src, //source for uncolored avatar animation
            colours:this.colours,
            size: this.size,
            orientation:this.orientation,

            where:this.where, //where it is equiped
            dimension: this.dimension.toDB(),
            collision: this.collision,
            baseItem: this.baseItem
        }
    }
    public toItem() : ItemBean {


        let item = new ItemBean();
        item.name=this.name;
        item.quantity=1;
        item.description=this.description
        item.cost=this.cost
        item.tokenId=this.tokenId        

        item.kind= this.kind //Behaviour for the item
        item.action= this.action //Behaviour for the item;
        item.closeAction=this.closeAction
        item.param=this.param
        item.closeParam=this.closeParam


        item.model= this.model,
        item.thumbnail=this.thumbnail, //address of uncolored image
        item.src=this.src, //source for uncolored avatar animation
        item.colours=this.colours,
        item.size=this.size,
        item.orientation=this.orientation,


        item.dimension= this.dimension
        item.collision= this.collision
        item.recipeId=this.id;
        item.where=this.where
        item.version=3
        return item;
    }

};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/recipe.bean.ts